import * as types from "~/store/invoice/types";

export const searchElectricInvoice = data => {
  return {
    type: types.SEARCH_ELECTRIC_INVOICES,
    data
  };
};

export const sendEmailInvoice = data => {
  return {
    type: types.SEND_EMAIL_INVOICE,
    data
  };
};
